import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[rowDetailTemplate]',
    standalone: false
})
export class RowDetailTemplateDirective<T> {
    constructor(public templateRef: TemplateRef<T>) {}
}
